<template>
  <FpPageBlock
    fullscreen
    children-type="column"
    :children="{ default: ['auto'], desktop: ['5fr', '6fr'] }"
  >
    <FpPageBlock :style="{ backgroundColor: '#E9EEFB' }">
      <FpFlex space-around :direction="FlexDirection.column">
        <FpFlexItem grow>
          <FpContainer border elevated grow>
            <FpFlex space-around :direction="FlexDirection.column">
              <FpFlexItem>
                <Header />
              </FpFlexItem>
              <FpFlexItem :hide="[MediaSection.xLarge, MediaSection.large]">
                <FpImage
                  :style="{ width: 'auto' }"
                  :title="$t('common.images.houseAndBuilding.title')"
                >
                  <img :src="houseAndBuilding" :alt="$t('common.images.houseAndBuilding.alt')" />
                </FpImage>
              </FpFlexItem>
              <FpFlexItem grow>
                <slot name="default" />
              </FpFlexItem>
            </FpFlex>
          </FpContainer>
        </FpFlexItem>
      </FpFlex>
    </FpPageBlock>
    <FpPageBlock
      hide-on="non-desktop"
      :style="{
        backgroundColor: '#E9EEFB',
        backgroundImage: `url(${houseAndBuilding})`,
        backgroundSize: '100%',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center right'
      }"
    >
    </FpPageBlock>
  </FpPageBlock>
</template>

<script>
import {
  FpFlex,
  FpFlexItem,
  FpImage,
  FpContainer,
  FpPageBlock,
  MediaSection
} from '@flatfair/vue-fairplay';
import houseAndBuilding from '@/images/house_and_building.png';
import Header from '@/components/header/header';
import FlexMixin from '@/libs/constants/flexMixin';

export default {
  components: {
    FpContainer,
    FpImage,
    FpFlex,
    FpFlexItem,
    FpPageBlock,
    Header
  },
  mixins: [FlexMixin],
  props: {},
  created() {
    this.houseAndBuilding = houseAndBuilding;
    this.MediaSection = MediaSection;
  },
  methods: {
    goToHome() {
      window.location = '/';
    }
  }
};
</script>
